import React from "react"
import Link from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Link"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPhone, faEnvelope, faFax } from "@fortawesome/pro-solid-svg-icons"
import Richtext from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Richtext"
import Image from "@yumgmbh/gatsby-theme-yum-components/src/components/atoms/Image"

import { useTranslation } from "react-i18next"

const TeamCard = ({ item }) => {
  const { i18n } = useTranslation()

  if (!item) {
    return null
  }

  let i18nDescription = ""
  let i18nInformation = ""

  if (i18n.language === "de") {
    i18nDescription = item.description
    i18nInformation = item.information
  } else {
    i18nDescription = item.description_en
    i18nInformation = item.information_en
  }

  return (
    <Link className="block" link={item?.link}>
      <div className="">
        {item?.image?.filename?.length > 0 && (
          <div className="mb-2 ">
            <Image
              image={item.image}
              className="h-auto mx-auto rounded-full w-28 "
              aspectRatio="1by1"
            />
          </div>
        )}
        <div className="text-center">
          {item?.name && (
            <span className="block font-semibold">{item.name}</span>
          )}
          {i18nDescription?.length > 0 && (
            <span className="block mb-2 text-sm text-gray-500">
              {i18nDescription}
            </span>
          )}
          {i18nInformation?.length > 0 && (
            <span className="block mb-2 text-sm">{i18nInformation}</span>
          )}
          {item?.tel && (
            <a
              className="block mb-2 text-sm text-primary hover:text-primary-hover"
              href={"tel:" + item.tel}
            >
              <FontAwesomeIcon icon={faPhone} size="1x" className="mr-1" />
              {item.tel}
            </a>
          )}
          {/* {item.fax && (
            <span className="block mb-2 text-sm">
              <FontAwesomeIcon icon={faFax} size="1x" className="mr-1" />
              {item.fax}
            </span>
          )} */}
          {item?.email && (
            <a
              className="block mb-2 text-sm text-primary hover:text-primary-hover"
              href={"mailto:" + item.email}
            >
              <FontAwesomeIcon icon={faEnvelope} size="1x" className="mr-1" />
              {item.email}
            </a>
          )}
          <Richtext className="prose-sm" text={item?.text} />
        </div>
      </div>
    </Link>
  )
}

export default TeamCard
